module.exports = __webpack_public_path__ + "img/fm-whatsapp-vs-gb-whatsapp.86372a21.webp";